import authLoader from '../../../routes/authLoader';
import PredictionMapPage from './PredictionMapPage';

export const predictionMapRoutes = [
  {
    path: 'map',
    element: <PredictionMapPage />,
    loader: authLoader,
  },
];
